"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSidebar = void 0;
var graphql_tag_1 = __importDefault(require("graphql-tag"));
var lodash_1 = require("lodash");
var react_1 = require("react");
var client_1 = require("@apollo/client");
var use_persisted_state_1 = __importDefault(require("use-persisted-state"));
var application_state_context_1 = require("../components/context/application-state-context");
var use_app_sections_1 = require("./use-app-sections");
var use_entities_1 = require("./use-entities");
var window_size_1 = require("@react-hook/window-size");
var usePersistedState = (0, use_persisted_state_1.default)('isSidebarShown');
var useSidebar = function () {
  var _a = __read(usePersistedState(null), 2),
    isShown = _a[0],
    setIsShown = _a[1];
  var _b = __read((0, react_1.useContext)(application_state_context_1.ApplicationStateContext), 2),
    appState = _b[0],
    setAppState = _b[1];
  var windowWidth = (0, window_size_1.useWindowWidth)();
  var isFloating = windowWidth < 1024;
  var entities = (0, use_entities_1.useEntities)();
  var appSections = (0, use_app_sections_1.useAppSections)();
  // find the app sections which have list-expandable entities, which we'll need to construct a query for
  var expandableEntities = (0, react_1.useMemo)(function () {
    return (0, lodash_1.map)((0, lodash_1.uniq)((0, lodash_1.reduce)(appSections, function (acc, appSection) {
      var expandableChildren = (0, lodash_1.filter)(appSection.children.map(function (child) {
        return !!entities[child.entityTypeName] && child.type === 'list-expandable' ? child.entityTypeName : null;
      }));
      return acc.concat(expandableChildren);
    }, [])), function (entityTypeName) {
      return entities[entityTypeName];
    });
  }, [entities, appSections]);
  // build a query for expanded entities.
  // we need the __type(name) part below so that this isn't a null query
  var SIDEBAR_QUERY = (0, react_1.useMemo)(function () {
    return (0, graphql_tag_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      query SidebarQuery {\n        __type(name: \"\") { name }\n        ", "\n      }\n    "], ["\n      query SidebarQuery {\n        __type(name: \"\") { name }\n        ", "\n      }\n    "])), expandableEntities.map(function (defn) {
      return "all".concat(defn.pluralTypeName, " { openGraph { image { id url thumbnails { id small { id url } } } } id name slug __typename ").concat(defn.sidebar.queryFields || '', " }");
    }));
  }, [expandableEntities]);
  var _c = (0, client_1.useQuery)(SIDEBAR_QUERY, {
      fetchPolicy: 'cache-first'
    }),
    loading = _c.loading,
    data = _c.data;
  var sidebarEntities = loading ? {} : expandableEntities.reduce(function (acc, defn) {
    var allKey = "all".concat(defn.pluralTypeName);
    if (data && data[allKey]) {
      acc[defn.name] = defn.sidebar.sort(data[allKey]);
    }
    return acc;
  }, {});
  return {
    show: function () {
      setIsShown(true);
      // Create a new resize event
      var resizeEvent = new Event('resize');
      // Dispatch the resize event on the window
      window.dispatchEvent(resizeEvent);
    },
    hide: function () {
      setIsShown(false);
      // Create a new resize event
      var resizeEvent = new Event('resize');
      // Dispatch the resize event on the window
      window.dispatchEvent(resizeEvent);
    },
    hideFloating: function () {
      if (isFloating) {
        setIsShown(false);
      }
    },
    toggle: function () {
      setIsShown(!isShown);
    },
    state: __assign(__assign({}, appState.sidebar), {
      isShown: isShown,
      isLoading: loading,
      entities: sidebarEntities
    }),
    isFloating: isFloating
  };
};
exports.useSidebar = useSidebar;
var templateObject_1;